import React, { useEffect, useState } from 'react'
import { DetallesEmpresas, getSession, getOrDeleteRequest } from "../utils/utils";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCircleUser, faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';
import Cookies from 'js-cookie';

import DataTableComponent from './DataTableComponent/DataTableComponent';

const CRUDEmpresas = () => {
	const [empresas, setEmpresas] = useState([]);
	const [id, setId] = useState('');
	const [search, setSearch] = useState('');
	const [role, setRole] = useState('');
	const [municipio, setMunicipio] = useState('');
	const [distrito, setDistrito] = useState('');
	const [naturaleza, setNaturaleza] = useState('');
	const [operation, setOperation] = useState(1);
	const [loading, setLoading] = useState(true);

	const columns = [
		{
			name: '#',
			width: '50px',
			selector: (row) => row.id
		},
		// {
        //     name: '# de Autorización',
        //     width: '180px',
        //     selector: (row) => row.id_autorizacion
        // },
        {
            name: 'Empresa',
            width: '300px',
            selector: (row) => row.nombre_empresa
        },
		{
            name: 'NIT de la empresa',
            width: '190px',
            selector: (row) => row.nit_empresa
        },
        {
            name: 'Encargado',
            width: '190px',
            selector: (row) => row.nombre_encargado
        },
        {
            name: 'Correo electrónico',
            width: '260px',
            selector: (row) => row.correo
        },
        {
            name: 'Tipo de acceso',
            width: '150px',
            selector: (row) => row.tipo_acceso ? row.tipo_acceso : 'No especificado'
        },
		// {
        //     name: 'Estado',
        //     width: '110px',
        //     selector: (row) => {
		// 		return row.status === 1 ? 
		// 			<span className="bg-green-100 text-green-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded-full dark:bg-green-200 dark:text-green-900">
		// 				Activo
		// 			</span>
		// 		: 
		// 			<span className="bg-red-100 text-red-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded-full dark:bg-red-200 dark:text-red-900">
		// 				Inactivo
		// 			</span>
		// 		;
		// 	}
        // },
    ];

	// async function getEmpresas() {
	const getEmpresas = async (page = 1, items = 10, search = null) => {
		setLoading(true);
		
		let uri = search ? `empresas?page=${page}&items=${items}&search=${search}` : `empresas?page=${page}&items=${items}`;
		let response = await getOrDeleteRequest(
			uri,
			'GET',
		);
		
		if (response.type === 'success') {
			setEmpresas(response.data);
		} else {
			setEmpresas([]);
		}
		setLoading(false);
	}

	useEffect(function () {
		if (!loading) return;
		getEmpresas();
	}, []);


	const eliminarEmpresa = async (nit_empresa) => {
		let session = Cookies.get("AuthToken");
		let uri = process.env.REACT_APP_API_URL + `admin/usuarios/${id}`;

		let config = {
			headers: {
				'Content-Type': 'multipart/form-data',
				'Authorization': `Bearer ${session}`,
			}
		};

		console.log(id, 'e')

		Swal.fire({
			title: "¿Estás seguro de borrar esta empresa?",
			text: "¡Esta acción no se puede deshacer!",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#d33",
			cancelButtonColor: "#3085d6",
			confirmButtonText: "Sí, eliminar",
			cancelButtonText: "Cancelar",
		}).then(async (result) => {
			if (result.isConfirmed) {
				try {
					await axios.delete(uri, config);
					setEmpresas((prevEmpresas) => prevEmpresas.filter((empresa) => empresa.id !== id));
					Swal.fire("¡Eliminado!", "La empresa ha sido eliminada.", "success");
				} catch (error) {
					console.error("Error al eliminar empresa", error);
					Swal.fire("Error", "No se pudo eliminar la empresa.", "error");
				}
			}
		});
	};

	const searcher = (e) => {
		setSearch(e.target.value);
	}

	const accesoUsuario = (e) => {
		console.log("Seleccionaste:", e.target.value)
		setRole(e.target.value);
	}

	// let results = empresas.filter((dato) =>
	// 	(role === "" || dato.tipo_acceso.trim().toLowerCase() === role.toLowerCase()) &&
	// 	(search === "" || dato.nombre_empresa.toLowerCase().includes(search.toLowerCase()))
	// );

	return (
		<>
			<div className="w-auto h-full py-10 px-3">
				<div className='flex flex-col justify-center w-auto h-auto items-center text-lg'>
					<div className="flex flex-col justify-center w-full mb-5">
						<div className="flex flex-row w-full justify-start items-start p-4">
							<Link to="/Mantenimiento" className="flex justify-start">
								<button className="bg-white border-4 border-[#0E7FA0] font-medium drop-shadow-2xl shadow-2xl text-white w-full rounded-full w-[50px] h-[50px] p-[12px]"><FontAwesomeIcon icon={faArrowLeft} className='text-[#0E7FA0] text-lg' /></button>
							</Link>
							<div className="flex flex-col w-full px-3 justify-between">
								<h1 className="text-4xl font-bold text-[#0E7FA0] text-start mb-2">Empresas</h1>
								<p className="text-base">
									Está diseñada para la edición de una Empresa. Aquí podrás modificar y actualizar la información existente de manera rápida y sencilla.
								</p>
							</div>
						</div>
					</div>
				</div>
				<div className='h-full w-auto mx-6'>
					<DataTableComponent
						nameTable={"Empresas"}
						data={empresas}	
						columns={columns}
						loading={loading}
						setLoading={setLoading}
						reload={getEmpresas}
						toEdit={'/EditarEmpresa/'}
						toDelete={'admin/empresas/'}
					/>
				</div>
			</div>
		</>
	)
}

export default CRUDEmpresas;